// Auto-derived application version. Sourced from package.json at build time
// so the footer always reflects what was actually shipped. Bump the version in
// package.json to update the footer everywhere.
import pkg from '../../package.json';

export const APP_VERSION = `${pkg.version}`;
